module.exports = __webpack_public_path__ + "static/media/20201121_222308_250_IMG_1020.01c5513d.jpg";